import { useQuery } from 'react-query';
import { UserType } from 'api/models';
import { ConfigurationApi } from 'api/timesheets/configuration/api';
import { GENERAL_API_STALE } from 'config/query-config';
import { useUser } from 'hooks/use-user';

export const TIMESHEET_CONFIGURATION_KEY = 'timesheets-configuration';

export const useTimesheetConfiguration = () => {
  const { user } = useUser();

  return useQuery(
    TIMESHEET_CONFIGURATION_KEY,
    () => {
      if (user.userType === UserType.Native) {
        return ConfigurationApi.get();
      }

      return null;
    },
    {
      staleTime: GENERAL_API_STALE,
    },
  );
};
